<lxm-dialog [dialogRef]="dialogRef" [formGroup]="form" #dialog>
  <span header-title
    >{{'cards.products.product_assortment_management_edit.title' | translate}}</span
  >
  <div body>
    <form-field
      dialog
      label="cards.products.product_assortment_management_edit.label.delivery_status"
      description="cards.products.product_assortment_management_edit.label_description.delivery_status"
    >
      <lxm-select
        select
        for="status"
        labelField="name"
        value="id"
        [options]="statuses"
        [clearable]="false"
      ></lxm-select>
      <validation-errors for="status"></validation-errors>
    </form-field>
  </div>
  <div footer class="justify-between">
    <span class="flex flex-row">
      <lxm-button
        type="orange"
        label="action.save"
        buttonType="submit"
        (click)="save()"
        [loading]="saveLoading"
      ></lxm-button>
      <lxm-button
        type="grey"
        label="action.cancel"
        class="ml10"
        (click)="closeDialog()"
      ></lxm-button>
    </span>
  </div>
</lxm-dialog>
